import React from 'react'
import styled from 'styled-components'
import NavigatorPCComponent from './components/navigator/NavigatorPCComponent'
import NavigatorMobileComponent from './components/navigator/NavigatorMobileComponent'
import { ReactComponent as LogoSVG } from '../assets/logo/main.svg'
import { useDevice } from '../hook/useDevice'
import { devices } from '../utils/responsive'
import { ReactComponent as TopArrowSVG } from '../assets/icon/top.svg'

const DefaultLayout: React.FC<any> = ({ children, ...props }) => {
  const { isMobile } = useDevice()
  const [scrollY, setScrollY] = React.useState(0)
  const moveToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })
  const checkPosition = React.useCallback(() => {
    const position = window.pageYOffset
    setScrollY(position)
  }, [])

  React.useEffect(() => {
    window.addEventListener('scroll', checkPosition, { passive: true })
    return () => {
      window.removeEventListener('scroll', checkPosition)
    }
  })

  return (
    <Wrap>
      <Header>
        <LogoSVG className='mainLogo' />
        {isMobile ? <NavigatorMobileComponent /> : <NavigatorPCComponent />}
      </Header>
      {children}
      {isMobile && scrollY > 0 && <TopArrowSVG className='btn-top' onClick={moveToTop} />}
    </Wrap>
  )
}

export default DefaultLayout

const Wrap = styled.div`
  position: relative;
  .btn-top {
    position: fixed;
    right: 34px;
    bottom: 6%;
    z-index: 999;
  }
`

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 52px 0 0 16.3%;
  z-index: 100;

  @media ${devices.mobile} {
    max-width: 100%;
    padding: 47px 32px 0;
    gap: unset;
    justify-content: space-between;
    min-width: 100%;

    .mainLogo {
      width: 103px;
      height: 34px;
    }
  }
`
